import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useSession } from "../../hooks/useSession";
import { supabase } from "../../lib/supabaseClient";
import "./Profile.css";

export default function PublicProfile() {
    const { username } = useParams();
    const { session } = useSession();

    const [profile, setProfile] = useState(null);
    const [loading, setLoading] = useState(true);
    const [msg, setMsg] = useState("");

    useEffect(() => {
        const load = async () => {
            setLoading(true);
            setMsg("");

            const u = (username || "").trim();
            if (!u) {
                setMsg("Invalid profile.");
                setLoading(false);
                return;
            }

            const { data, error } = await supabase
                .from("profiles")
                .select(
                    "username, display_name, bio, avatar_url, is_public, user_id",
                )
                .eq("username", u)
                .maybeSingle();

            setLoading(false);

            if (error) {
                setMsg(error.message);
                return;
            }

            if (!data) {
                setMsg("This profile doesn't exist or is private.");
                return;
            }

            setProfile(data);
        };

        load();
    }, [username]);

    if (loading) {
        return (
            <div className="profile-container">
                <div className="profile-card">
                    <h2>Profile</h2>
                    <p className="profile-subtext">Loading…</p>
                </div>
            </div>
        );
    }

    if (!profile) {
        return (
            <div className="profile-container">
                <div className="profile-card">
                    <h2>Profile</h2>
                    <p className="profile-subtext">{msg || "Not found."}</p>
                </div>
            </div>
        );
    }

    const isOwner = session?.user?.id === profile.user_id;

    // If your RLS is set correctly, private profiles won't be returned unless owner.
    // But this keeps UI honest if you ever loosen selects later.
    if (!profile.is_public && !isOwner) {
        return (
            <div className="profile-container">
                <div className="profile-card">
                    <h2>Private profile</h2>
                    <p className="profile-subtext">
                        This user hasn’t made their profile public.
                    </p>
                </div>
            </div>
        );
    }

    return (
        <div className="profile-container">
            <div className="profile-card">
                <h2>{profile.display_name || profile.username}</h2>
                <p className="profile-subtext">@{profile.username}</p>

                {profile.avatar_url ? (
                    <div className="profile-avatar-wrap">
                        <img
                            className="profile-avatar"
                            src={profile.avatar_url}
                            alt="avatar"
                        />
                    </div>
                ) : null}

                {profile.bio ? (
                    <div className="profile-bio">{profile.bio}</div>
                ) : null}

                <div className="profile-footer">
                    {isOwner ? (
                        <a className="profile-secondary" href="/me">
                            Edit my profile
                        </a>
                    ) : null}
                </div>
            </div>
        </div>
    );
}
